import { render } from "./EmergencyContactsForm.vue?vue&type=template&id=6fa1ba2c&ts=true"
import script from "./EmergencyContactsForm.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactsForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__